import React from 'react'
import _ from 'lodash'
import { StyleSheet, View, Text } from '@react-pdf/renderer'
import helpers from '../../../utils/helpers'

const Table = ({ startFrom, endAt, type, subtotal, rielRate }) => {
  return (
    <React.Fragment>
      <View
        wrap={false}
        style={{
          ...tableStyles.tr,
          ...tableStyles.tableRow,
          ...tableStyles.headerHeight,
          borderTop: 1,
          borderLeft: 1,
          borderRight: 1,
          borderBottom: 0.5,
        }}
      >
        <View style={{ ...tableStyles.td, ...tableStyles.firstColumn, ...tableStyles.headerColor }}>
          <Text style={{ ...tableStyles.p16, ...fonts.ft8 }}>ល.រ</Text>
          <Text style={{ ...tableStyles.p16, ...fonts.ft3 }}>No.</Text>
        </View>

        <View style={{ ...tableStyles.td, ...tableStyles.secondColumn, ...tableStyles.headerColor }}>
          <Text style={{ ...tableStyles.p13, ...fonts.ft8 }}>បរិយាយមុខទំនិញ</Text>
          <Text style={{ ...tableStyles.p17, ...fonts.ft3 }}>Description</Text>
        </View>

        <View style={{ ...tableStyles.td, ...tableStyles.thirdColumn, ...tableStyles.headerColor }}>
          <Text style={{ ...tableStyles.p14, ...fonts.ft8 }}>រយៈពេល / </Text>

          <Text style={{ ...tableStyles.p14, ...fonts.ft3 }}>Period</Text>
        </View>

        <View style={{ ...tableStyles.td, ...tableStyles.fourthColumn, ...tableStyles.headerColor }}>
          <Text style={{ ...tableStyles.alignLeftNoWrap, ...fonts.ft8 }}>បរិមាណ</Text>
          <Text style={{ ...tableStyles.alignLeftNoWrap, ...fonts.ft3 }}>Quantity</Text>
        </View>

        <View style={{ ...tableStyles.td, ...tableStyles.fifthColumn, ...tableStyles.headerColor }}>
          <Text style={{ ...tableStyles.p15, ...fonts.ft8 }}>ថ្លៃសេវាកម្ម{'   '}</Text>
          <Text style={{ ...tableStyles.p15, ...fonts.ft3 }}>Service Fee</Text>
        </View>
      </View>
      {displayMerchantRow(subtotal, startFrom, endAt)}
      <DisplayTableFooter subtotal={subtotal} rielRate={rielRate} type={type} />
    </React.Fragment>
  )
}

const DisplayTableFooter = ({ subtotal, rielRate, type }) => {
  if (type === 'tax') {
    return <TaxTable subtotal={subtotal} rielRate={rielRate} />
  } else if (type === 'market') {
    return <MarketTable subtotal={subtotal} />
  } else if (type === 'commercial') {
    return <CommercialTable subtotal={subtotal} rielRate={rielRate} />
  }
}
const MarketTable = ({ subtotal }) => {
  const overallSubtotal = parseFloat(_.sum(Object.values(subtotal)))
  const displaySubtotal = helpers.numberToUsd(overallSubtotal)
  return (
    <React.Fragment>
      <View
        wrap={false}
        style={{
          ...tableStyles.tr,
          ...tableStyles.tableRow,
          borderLeft: 1,
          borderRight: 1,
          borderBottom: 0.5,
          borderTop: 0.5,
          height: 30,
        }}
      >
        <View
          style={{
            width: 425,
            borderRight: 1,
            textAlign: 'right',
            justifyContent: 'center',
            paddingRight: 10,
          }}
        >
          <Text>
            <Text style={{ ...fonts.ft4, width: 20 }}>ថ្លៃសរុប</Text>
            <Text style={{ ...fonts.ft2 }}>/</Text>
            <Text style={{ ...fonts.ft2 }}>Total</Text>
          </Text>
        </View>
        <View style={{ ...tableStyles.td57, paddingLeft: 10 }}>
          <Text style={{ ...fonts.ft2 }}>{displaySubtotal} </Text>
        </View>
      </View>
      <View
        wrap={false}
        style={{
          ...tableStyles.tr,
          ...tableStyles.tableRow,
          borderLeft: 1,
          borderRight: 1,
          borderTop: 0.5,
          borderBottom: 0.5,
          height: 70,
        }}
      >
        <View
          style={{
            width: 304,
            borderRight: 1,
            borderBottom: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <View style={{ ...tableStyles.trCenter }}>
            <Text>
              <Text style={{ ...fonts.ft2 }}>Payable Name: </Text>
              <Text style={{ ...fonts.ft2 }}>ABA Bank</Text>
            </Text>
            <Text>
              <Text style={{ ...fonts.ft2 }}>Account Name: </Text>
              <Text style={{ ...fonts.ft2 }}>Ommaly Heng</Text>
            </Text>
            <Text>
              <Text style={{ ...fonts.ft2 }}>Account No: </Text>
              <Text style={{ ...fonts.ft2 }}>001 652 732</Text>
            </Text>
            <Text>
              <Text style={{ ...fonts.ft2 }}>Contact Number: </Text>
              <Text style={{ ...fonts.ft2 }}>010 70 80 39</Text>
            </Text>
          </View>
        </View>

        <View
          style={{
            width: 202,
            display: 'flex',
            borderRight: 1,
            borderBottom: 1,
          }}
        >
          <Text style={{ ...fonts.ft2, paddingLeft: 5, paddingTop: 10 }}>
            {' '}
            Cannot be used for tax declaration{' '}
          </Text>
        </View>
      </View>
    </React.Fragment>
  )
}

const CommercialTable = ({ rielRate, subtotal }) => {
  const VAT = 0.1
  const overallSubtotal = parseFloat(_.sum(Object.values(subtotal)))

  const vatFee = overallSubtotal * VAT
  const grandTotal = overallSubtotal + vatFee
  const grandTotalInRiel = grandTotal * rielRate

  const displayRielRate = helpers.numberToRiel(rielRate)
  const displayGrandTotal = helpers.numberToUsd(grandTotal)
  const displayGrandTotalInRiel = helpers.numberToRiel(grandTotalInRiel)
  return (
    <React.Fragment>
      <View
        style={{
          ...tableStyles.tr,
          ...tableStyles.tableRow,
          borderLeft: 1,
          borderRight: 1,
          borderBottom: 0.5,
          borderTop: 0.5,
          height: 30,
        }}
      >
        <View
          style={{
            width: 425,
            borderRight: 1,
            textAlign: 'right',
            justifyContent: 'center',
            borderTop: 0.5,
            borderBottom: 0.5,
            paddingRight: 10,
          }}
        >
          <Text style={{ margin: 0 }}>
            <Text style={{ ...fonts.ft4 }}>ថ្លៃសរុប (បូកបញ្ចូលទាំងអាករ)</Text>
            <Text style={{ ...fonts.ft3 }}> Total (VAT included) </Text>
          </Text>
        </View>
        <View style={{ ...tableStyles.td57, paddingLeft: 10 }}>
          <Text style={{ ...fonts.ft2 }}>{displayGrandTotal} </Text>
        </View>
      </View>

      <View
        wrap={false}
        style={{
          ...tableStyles.tr,
          ...tableStyles.tableRow,
          borderLeft: 1,
          borderRight: 1,
          borderBottom: 0.5,
          borderTop: 0.5,
          height: 70,
        }}
      >
        <View
          style={{
            width: 304,
            borderRight: 0.5,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text style={{ ...tableStyles.p17, ...fonts.ft8 }}>សូមអរគុណចំពោះអាជីវកម្មរបស់អ្នក{'   '}</Text>
          <Text style={{ ...tableStyles.p17, ...fonts.ft12 }}>Thank you for your business</Text>
        </View>

        <View>
          <View
            style={{
              ...tableStyles.td5,
              ...tableStyles.trFlex,
              borderBottom: 1,
              borderLeft: 0.5,
              height: 35,
            }}
          >
            <View style={{ ...tableStyles.td130 }}>
              <Text style={{ ...fonts.ft8 }}> អត្រាប្តូរប្រាក់ជាប្រាក់រៀល{'   '}</Text>
              <Text style={{ ...fonts.ft2 }}>Exchange Rate in Riel</Text>
            </View>
            <View
              style={{
                ...tableStyles.td57,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Text style={{ ...fonts.ft2 }}>{displayRielRate}</Text>
            </View>
          </View>

          <View
            style={{
              ...tableStyles.td5,
              ...tableStyles.trFlex,
              borderBottom: 1,
              borderLeft: 0.5,
              height: 35,
            }}
          >
            <View
              style={{
                ...tableStyles.td130,
              }}
            >
              <Text style={{ ...fonts.ft8 }}> តំលៃ​បូក​សរុបជាប្រាក់រៀល{'   '}</Text>
              <Text style={{ ...fonts.ft2 }}>Grand Total in Riel</Text>
            </View>
            <View
              style={{
                ...tableStyles.td57,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Text style={{ ...fonts.ft2 }}>{displayGrandTotalInRiel}</Text>
            </View>
          </View>
        </View>
      </View>
    </React.Fragment>
  )
}

const TaxTable = ({ subtotal, rielRate }) => {
  const overallSubtotal = parseFloat(_.sum(Object.values(subtotal)))
  const parseRielRate = parseFloat(rielRate)
  const VAT = 0.1
  const vatFee = _.round(overallSubtotal * VAT, 2)
  const grandTotal = _.round(overallSubtotal + vatFee, 2)
  const grandTotalInRiel = _.round(grandTotal * parseRielRate, 0)

  const displayRielRate = helpers.numberToRiel(parseRielRate)
  const displaySubtotal = helpers.numberToUsd(overallSubtotal)
  const displayVatFee = helpers.numberToUsd(vatFee)
  const displayGrandTotal = helpers.numberToUsd(grandTotal)
  const displayGrandTotalInRiel = helpers.numberToRiel(grandTotalInRiel)
  return (
    <React.Fragment>
      <View
        wrap={false}
        style={{
          ...tableStyles.tr,
          ...tableStyles.tableRow,
          borderTop: 0.5,
          borderBottom: 0.5,
          borderLeft: 1,
          borderRight: 1,
          height: 108,
        }}
      >
        <View style={{ ...tableStyles.td302 }}>
          <Text style={{ ...fonts.ft2, paddingTop: 10 }}>
            Payment can be made by cheque or deposit to our bank account.
          </Text>
          <Text style={{ marginTop: 20 }}>
            <Text style={{ ...fonts.ft2 }}>Bank Name: </Text>
            <Text style={{ ...fonts.ft3, ...styles.span }}>Advanced Bank of Asia Ltd. (ABA Bank)</Text>
          </Text>
          <Text>
            <Text style={{ ...fonts.ft2 }}>Account Name: </Text>
            <Text style={{ ...fonts.ft3, ...styles.span }}>MUUVE TECH CO., LTD</Text>
          </Text>
          <Text>
            <Text style={{ ...fonts.ft2 }}>Account Number: </Text>
            <Text style={{ ...fonts.ft3, ...styles.span }}>001508936</Text>
          </Text>
        </View>

        <View>
          <View
            style={{
              ...tableStyles.rowHeight,
              ...tableStyles.td5,
              ...tableStyles.trFlex,
              borderBottom: 0.5,
            }}
          >
            <View style={{ ...tableStyles.rowHeight, ...tableStyles.td130 }}>
              <Text style={{ ...fonts.ft8 }}> សរុប{'   '}</Text>
              <Text style={{ ...fonts.ft2 }}> Sub Total </Text>
            </View>

            <View style={{ ...tableStyles.td57 }}>
              <Text style={{ ...tableStyles.p15, ...fonts.ft2 }}>{displaySubtotal} </Text>
            </View>
          </View>
          <View
            style={{
              ...tableStyles.rowHeight,
              ...tableStyles.td5,
              ...tableStyles.trFlex,
              borderBottom: 0.5,
            }}
          >
            <View style={{ ...tableStyles.rowHeight, ...tableStyles.td130 }}>
              <Text style={{ ...fonts.ft8 }}> អាករលើតំលៃបន្ថែម ១០%{'   '}</Text>
              <Text style={{ ...fonts.ft2 }}>VAT 10%</Text>
            </View>
            <View style={{ ...tableStyles.td57 }}>
              <Text style={{ ...tableStyles.p15, ...fonts.ft2 }}>{displayVatFee}</Text>
            </View>
          </View>
          <View
            style={{
              ...tableStyles.rowHeight,
              ...tableStyles.td5,
              ...tableStyles.trFlex,
            }}
          >
            <View style={{ ...tableStyles.rowHeight, ...tableStyles.td130 }}>
              <Text style={{ ...fonts.ft8 }}> តំលៃ​បូក​សរុប{'   '}</Text>
              <Text style={{ ...fonts.ft2 }}>Grand Total</Text>
            </View>
            <View style={{ ...tableStyles.td57 }}>
              <Text style={{ ...tableStyles.p15, ...fonts.ft2 }}>{displayGrandTotal} </Text>
            </View>
          </View>
        </View>
      </View>

      <View
        style={{
          ...tableStyles.tr,
          ...tableStyles.tableRow,
          borderTop: 0.5,
          borderLeft: 1,
          borderRight: 1,
          borderBottom: 1,

          height: 72,
        }}
        wrap={false}
      >
        <View
          style={{
            ...tableStyles.td302,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text style={{ ...tableStyles.p17, ...fonts.ft8 }}>សូមអរគុណចំពោះអាជីវកម្មរបស់អ្នក{'   '}</Text>
          <Text style={{ ...tableStyles.p17, ...fonts.ft12 }}>Thank you for your business</Text>
        </View>

        <View>
          <View
            style={{
              ...tableStyles.rowHeight,
              ...tableStyles.td5,
              ...tableStyles.trFlex,
              borderBottom: 0.5,
            }}
          >
            <View style={{ ...tableStyles.rowHeight, ...tableStyles.td130 }}>
              <Text style={{ ...fonts.ft8 }}> អត្រាប្តូរប្រាក់ជាប្រាក់រៀល{'   '}</Text>
              <Text style={{ ...fonts.ft2 }}>Exchange Rate in Riel</Text>
            </View>
            <View style={{ ...tableStyles.td57 }}>
              <Text style={{ ...tableStyles.p15, ...fonts.ft2 }}>{displayRielRate}</Text>
            </View>
          </View>

          <View
            style={{
              ...tableStyles.rowHeight,
              ...tableStyles.td5,
              ...tableStyles.trFlex,
            }}
          >
            <View style={{ ...tableStyles.rowHeight, ...tableStyles.td130 }}>
              <Text style={{ ...fonts.ft8 }}> តំលៃ​បូក​សរុបជាប្រាក់រៀល{'   '}</Text>
              <Text style={{ ...fonts.ft2 }}>Grand Total in Riel</Text>
            </View>
            <View style={{ ...tableStyles.td57 }}>
              <Text wrap style={{ ...tableStyles.p15, ...fonts.ft2 }}>
                {displayGrandTotalInRiel}
              </Text>
            </View>
          </View>
        </View>
      </View>
    </React.Fragment>
  )
}

const displayMerchantRow = (orders, startFrom, endAt) => {
  const componentArray = []
  const orderKeys = Object.keys(orders)
  const orderLength = orderKeys.length

  for (let index = 0; index < orderLength; index++) {
    const merchantName = orderKeys[index]
    const total = orders[merchantName]
    const newIndex = index + 1

    componentArray.push(
      <View
        key={newIndex}
        wrap={false}
        style={{
          ...tableStyles.tr,
          ...tableStyles.tableRow,
          height: 60,
          borderTop: 0.5,
          borderBottom: 0.5,
          borderLeft: 1,
          borderRight: 1,
        }}
      >
        <View style={{ ...tableStyles.totalRowHeight, ...tableStyles.td41 }}>
          <Text style={{ ...fonts.ft2, paddingLeft: 10 }}>{newIndex}</Text>
        </View>
        <View
          style={{
            ...tableStyles.totalRowHeight,
            ...tableStyles.totalContentColumn,
          }}
        >
          <Text style={{ ...tableStyles.p17, ...fonts.ft8 }}>
            <Text>កម្រៃជើងសារលើការ</Text>
            <Text>បញ្ជាទិញតាមអ៊ីនធឺណិត{'   '}</Text>
          </Text>
          <Text style={{ ...tableStyles.p17, ...fonts.ft12 }}>Commission on Online Order</Text>
          <Text style={{ ...tableStyles.p17, ...fonts.ft12 }}>({merchantName})</Text>
        </View>

        <View style={{ ...tableStyles.totalRowHeight, ...tableStyles.td56, textAlign: 'center' }}>
          <Text style={{ ...tableStyles.alignLeftNoWrap, ...fonts.ft2 }}>{startFrom} to</Text>
          <Text style={{ ...tableStyles.alignLeftNoWrap, ...fonts.ft2 }}>{endAt}</Text>
        </View>

        <View style={{ ...tableStyles.totalRowHeight, ...tableStyles.td23, textAlign: 'center' }}>
          <Text style={{ ...tableStyles.alignLeftNoWrap, ...fonts.ft2 }}>1</Text>
        </View>

        <View style={{ ...tableStyles.totalRowHeight, ...tableStyles.td57 }}>
          <Text style={{ ...tableStyles.p15, ...fonts.ft2 }}>{helpers.numberToUsd(total)} </Text>
        </View>
      </View>
    )
  }
  return componentArray
}

const tableStyles = StyleSheet.create({
  trFlex: { display: 'flex', flexDirection: 'row' },
  colFlex: { display: 'flex', flexDirection: 'column' },

  headerColor: {
    backgroundColor: '#ffe599',
    textAlign: 'center',
  },
  firstColumn: {
    borderRight: 1,
    width: 30,
  },
  secondColumn: {
    borderRight: 1,
    width: 275,
  },
  thirdColumn: {
    borderRight: 1,
    width: 70,
  },
  fourthColumn: {
    borderRight: 1,
    width: 50,
  },
  fifthColumn: {
    width: 80,
  },

  tr: { display: 'flex', flexDirection: 'row' },
  headerHeight: { height: 50 },
  tableRow: { marginLeft: 45, width: 507 },

  spacingRow: { height: 30 },

  td: { padding: 0, margin: 0, display: 'flex', justifyContent: 'center', textAlign: 'center' },

  totalRowHeight: { height: 60, display: 'flex', justifyContent: 'center' },
  td1: { width: 150 },
  td5: { width: 200 },
  td12: { width: 125 },
  td56: {
    borderRight: 1,
    width: 70,
  },
  td23: {
    borderRight: 1,
    width: 50,
  },

  td41: {
    borderRight: 1,
    width: 30,
  },

  totalContentColumn: {
    borderRight: 1,

    width: 275,
    paddingLeft: 10,
    paddingTop: 5,
    paddingBottom: 5,
    display: 'flex',
    justifyContent: 'space-between',
  },
  td130: {
    width: 120,
    paddingLeft: 10,
    borderRight: 1,
    justifyContent: 'center',
  },
  td100: { width: 100 },
  tr3: { height: 16 },

  td302: { borderRight: 1, width: 305, paddingLeft: 5 },
  td57: { width: 70, paddingLeft: 5, display: 'flex', justifyContent: 'center', alignItems: 'flex-start' },
  // tr13: { height: 28 },
  rowHeight: { height: 36 },
})

const fonts = StyleSheet.create({
  ft0: {
    fontSize: 16,
    fontFamily: 'Nokora Bold',
  },
  ft1: {
    fontSize: 14,
    fontFamily: 'Montserrat',
  },
  ft2: {
    fontSize: 9,
    fontFamily: 'Montserrat',
  },
  ft3: {
    fontSize: 9,
    fontFamily: 'Montserrat Bold',
  },
  ft4: {
    fontSize: 9,
    fontFamily: 'Nokora',
  },
  ft8: {
    fontSize: 9,
    fontFamily: 'Nokora Bold',
  },
  ft12: {
    fontSize: 9,
    fontFamily: 'Montserrat',
    color: '#232222',
  },
})

const styles = StyleSheet.create({
  p9: {
    textAlign: 'left',
    paddingLeft: 40,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },

  p13: {
    textAlign: 'left',
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p14: {
    textAlign: 'center',

    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p15: {
    textAlign: 'left',
    paddingLeft: 31,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p16: {
    textAlign: 'left',
    paddingLeft: 10,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  p17: {
    textAlign: 'left',
    paddingLeft: 150,
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },
  alignLeftNoWrap: {
    textAlign: 'left',
    marginTop: 0,
    marginBottom: 0,
    whiteSpace: 'nowrap',
  },

  span: {
    display: 'inline',
  },
})
export default Table



// WEBPACK FOOTER //
// ./src/components/invoice/shared/Table.js